import * as React from "react";

export const PackagesStandaloneWizardModulesContext = React.createContext<React.ReactElement[]>([]);
